import React, { useEffect } from 'react';
import './RedirectToCheckout.scss';

const RedirectToCheckout = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const redirectUrl = queryParams.get('redirect_url');

  useEffect(() => {
    if (!redirectUrl) return;

    window.location.replace(redirectUrl);
  }, [redirectUrl]);

  return (
    <div className="redirecting-page">
      <div className="redirecting-text">
        Redirecting to checkout, please wait
        <div className="loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default RedirectToCheckout;
